import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BiasingPolicyService {

  private readonly http = inject(HttpClient);

  getBiasingList(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    biasingFilter: string | { search?: string; clientId?: number }
  ): Observable<any> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy);

    // Normalizza i filtri
    let search = '';
    let clientId: number | undefined;

    if (typeof biasingFilter === 'string') {
      search = (biasingFilter ?? '').trim();
    } else if (biasingFilter && typeof biasingFilter === 'object') {
      if (typeof biasingFilter.search === 'string') {
        search = biasingFilter.search.trim();
      }
      if (typeof biasingFilter.clientId === 'number') {
        clientId = biasingFilter.clientId;
      }
    }
    if (search)   params = params.set('search', search);
    if (clientId !== undefined && !Number.isNaN(clientId)) {
      params = params.set('clientId', String(clientId));
    }

    return this.http.get<any>(`${environment.api.host_path}/biasing/list`, { params });
  }

  getBiasingListAll(): Observable<any> {
    return this.http.get<any>(`${environment.api.host_path}/biasing/listAll`);
  }

  addNewBiasingPolicy(params: any): Observable<any> {
    return this.http.post(`${environment.api.host_path}/biasing`, params);
  }

  addOrEditFieldToBiasing(params: any, biasingId: string): Observable<any> {
    return this.http.put(`${environment.api.host_path}/biasing/${biasingId}/add-field`, params);
  }

  addOrEditAliasToBiasing(params: any, biasingId: string): Observable<any> {
    return this.http.put(`${environment.api.host_path}/biasing/${biasingId}/add-alias`, params);
  }

  editBiasingPolicy(params: any): Observable<any> {
    return this.http.put(`${environment.api.host_path}/biasing`, params);
  }

  deleteBiasingPolicy(id: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/biasing/${id}`);
  }

  removeFieldFromBiasing(biasingId: number, fieldId: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/biasing/${biasingId}/remove-field/${fieldId}`);
  }

  removeAliasFromBiasing(biasingId: number, aliasId: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/biasing/${biasingId}/remove-alias/${aliasId}`);
  }
}
